import * as TSE from 'ts-events';
import { HtmlComponent } from './../html-component';

// import html
import template from './editable-text-component.hogan.html';

// js

export class EditableTextComponent extends HtmlComponent {
    private inputField: any;
    public change = new TSE.SyncEvent();

    constructor(parameters: {
        text: string;
        prefixLabel: string;
        suffixLabel: string;
        name: string;
        extraClass: string;
    }) {
        super(template, parameters);

        this.inputField = this.jqueryElement.find('.editable-text-component-input');
        this.inputField.val(parameters.text);
        this.inputField.change(() => {
            this.change.post(this.inputField.val());
        });
    }

    public enable() {
        this.jqueryElement.addClass('editable-text-component-enabled');
        this.jqueryElement.removeClass('editable-text-component-disabled');
    }

    public disable() {
        this.jqueryElement.removeClass('editable-text-component-enabled');
        this.jqueryElement.addClass('editable-text-component-disabled');
    }

    public hide() {
        this.jqueryElement.hide();
    }

    public show() {
        this.jqueryElement.show();
    }

    public setText(text: string) {
        this.inputField.val(text);
    }
}
